import CSelect from "@/components/main/form/CSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconBuildingCommunity } from "@tabler/icons-react";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const CompanyTypeInput = ({
  dictionary,
  form,
  creatable = true,
  clearable = false,
}) => {
  const [companyTypes, setCompanyTypes] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);
  const createType = async (type) => {
    try {
      const db = getFirestore(firebase_app);
      await addDoc(collection(db, "CompanyTypes"), {
        name: type,
        lowerCaseName: type.toLowerCase(),
      });
    } catch (error) {}
  };

  const getTypes = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(
          collection(db, "CompanyTypes"),
          orderBy("lowerCaseName"),
          limit(4)
        )
        : query(
          collection(db, "CompanyTypes"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let typesQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        typesQueried.push(data?.name);
      });

      setCompanyTypes(typesQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTypes("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getTypes(search);
    }
  }, [search]);

  return (
    <CSelect
      searchable
      creatable={creatable}
      clearable={clearable}
      data={
        form.values.type
          ? Array.from(new Set([form.values.type, ...companyTypes]))
          : companyTypes
      }
      placeholder={dictionary.type}
      className="mt-3"
      icon={<IconBuildingCommunity />}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      onCreate={(value) => {
        setCompanyTypes((data) => [...data, value]);
        form.setFieldValue("type", value);
        createType(value);
      }}
      getCreateLabel={(query) => {
        return (
          <>
            <span className="text-primary">{dictionary.createItem}: </span>
            {query}
          </>
        );
      }}
      rightSection={loading && <Loader variant="oval" />}
      {...form.getInputProps("type")}
    />
  );
};

export default CompanyTypeInput;
